<template>
  <div class="o-login">



    <app-navigation></app-navigation>



    <main class="o-login__main">



      <div class="o-login__main__logo c-login-logo">
        <img :src="platformImages.login_logo"
             :srcset="platformImages.login_logo+ ', ' +
                     platformImages.login_logo_2x + ' 2x'"
             :alt="$t('web.login.alt_text_login_logo')">
      </div>



      <section class="c-card c-card--login js-login-card">
        <form>


          <div class="c-card__header">
            <h2 class="c-card__title t-headline">{{ $t('web.login.card_header') }}</h2>
          </div>

          <div class="c-card__body">

              <div class="c-validation t-toast-danger is-not-valid" v-if="error_message">
                {{ error_message }}
              </div>

              <fieldset class="o-fieldset">

                <label class="c-card__subtitle-h3" for="username">{{ $t('web.login.email_label') }}</label>

                <input id="username" type="email" placeholder="" v-model="request.username" :class="{ 'is-not-valid': errors.username }" required>

                <div class="c-validation t-alert-danger is-not-valid" id="username-error" for="username"
                     v-if="errors.username">{{ errors.username[0] }}</div>

              </fieldset>

              <fieldset class="o-fieldset">

                <label class="c-card__subtitle-h3" for="password">{{ $t('web.login.password_label') }}</label>

                <input id="password" type="password" placeholder="" v-model="request.password" :class="{ 'is-not-valid': errors.password }" required>

                <div class="c-validation t-alert-danger is-not-valid" id="password-error" for="password" v-if="errors.password">{{ errors.password[0] }}</div>

              </fieldset>


          </div>

          <div class="c-card__footer c-card--login__footer">

            <button 
              class="c-button c-button--full-width t-button-primary js-submit-login"
              :disabled = "loggingIn"
              @click="submit($event)">
              {{ $t('web.login.submit_button') }}
            </button>
            <router-link v-if="websiteConfig.enrollment_enabled" class="c-card__footer__text-link u-float-left t-link" :to="{name: 'Signup'}">{{ $t('web.login.signup_link_text') }}</router-link>
            <router-link class="c-card__footer__text-link u-float-right t-link" :to="{name: 'ForgotPassword'}">{{ $t('web.login.forgot_password_link_text') }}</router-link>
          </div>

        </form>
      </section><!-- /c-card -->



    </main>

    <app-footer></app-footer>



    <div class="c-login-hero-image">
      <picture>

        <source :srcset="platformImages.login_background_desktop + ', ' +
                        platformImages.login_background_desktop_2x + ' 2x'"
                media="(min-width: 960px)">

        <source :srcset="platformImages.login_background_tablet + ', ' +
                        platformImages.login_background_tablet_2x + ' 2x'"
                media="(min-width: 580px) and (min-height: 580px)">

        <source :srcset="platformImages.login_background_mobile + ', ' +
                        platformImages.login_background_mobile_2x + ' 2x'"
                media="(max-width: 580px)">

        <img :src="platformImages.login_background_tablet_wide"
             :srcset="platformImages.login_background_tablet_wide + ', ' +
                     platformImages.login_background_tablet_wide_2x + ' 2x'"
             :alt="$t('web.login.alt_text_background_image')">

      </picture>
    </div>
  </div>
</template>










<script>
import $ from 'jquery'
import API from '@/services'
import validate from 'validate.js'
import util from '@/functions'
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  name: 'login',
  data () {
    return {
      request: {
        grant_type: 'password',
        username: null,
        password: null,
        platform_id: null,
        scope: ''
      },
      errors: {
        username: null,
        password: null
      },
      error_message: '',
      loggingIn: false
    }
  },

  computed: {
    ...mapGetters({
      appName: 'appName',
      websiteConfig: 'websiteConfig',
      platformImages: 'platformImages'
    })
  },

  mounted () {
    util.initLoginCard($('input[type="password"]'))
    const browserLang = window.navigator.language
    API.get('website-config?url=' + encodeURIComponent(window.location.href) + '&lang=' + browserLang + '&prefix=login')
      .then((resp) => {
        util.addPlatformLanguage(resp.data.websiteConfig.language)
        this.UPDATE_WEBSITE_CONFIG(resp.data.websiteConfig)
      })
      .catch((err) => {
        if (err.response.status === 404) {
          this.$router.push({ name: 'NotFound' })
        }
      })
  },

  methods: {
    ...mapActions([
      'LOGIN',
      'WEBSITE_CONFIG_AUTH_UPDATE'
    ]),

    ...mapMutations(['UPDATE_WEBSITE_CONFIG']),

    submit (e) {
      e.preventDefault()
      if (this.loggingIn) {
        return
      }
      this.loggingIn = true
      this.errors = { username: null, password: null }
      this.error_message = ''
      let errors = this.validate()
      if (errors) {
        this.errors = errors
        util.shake($('.js-login-card'))
        this.loggingIn = false
        return
      }
      this.request.platform_id = this.websiteConfig.id
      this.LOGIN(this.request)
        .then(() => {
          this.WEBSITE_CONFIG_AUTH_UPDATE(this.$router).then(() => {
            this.$router.push({ name: 'Dashboard' })
            this.loggingIn = false
            return
          })
        })
        .catch(err => {
          this.error_message = this.$t(err.message)

          switch (err.type) {
            case 'invalid_username':
              util.highlight('username')
              break
            case 'invalid_password':
              util.highlight('password')
              break
          }
          util.shake($('.js-login-card'))
          this.loggingIn = false
          return
        })
    },

    validate () {
      const constraints = {
        username: {
          email: {
            message: this.$t('utils.validation.email')
              .replace('{attribute}', validate.capitalize(validate.prettify('email')))
          },
          presence: {
            message: this.$t('utils.validation.required')
              .replace('{attribute}', validate.capitalize(validate.prettify('email')))
          }
        },
        password: {
          presence: {
            message: this.$t('utils.validation.required')
              .replace('{attribute}', validate.capitalize(validate.prettify('password')))
          }
        }
      }

      return validate(this.request, constraints, {fullMessages: false})
    }
  }
}
</script>
<style lang="sass" scoped>
</style>



// WEBPACK FOOTER //
// Login.vue?0ae2b9dc